/**
 * Auth-less routes (noLayout) - receipt prints, forgot password, etc.
 */
import Receipt from "@/containers/events/receipt/ReceiptPrint";
import RentReceiptPrint from "@/containers/bookings/rent-booking-receipt/RentReceiptPrint";
import LagatReceiptPrint from "@/containers/lagat-receipt/LagatReceiptPrint";
import ForgotPassword from "@/layout/ForgotPassword";
import ResetPassword from "@/layout/ResetPassword";
import SabilReceipt from "@/containers/sabil/sabil-receipt/SabilReceiptPrint";
import FmbReceipt from "@/containers/fmb/fmb-receipt/FmbReceiptPrint";
import FmbThaliDistributorLogin from "@/containers/fmb/fmb-thali-distributor/FmbThaliDistributorLogin";
import YearlyNiyaazReceiptPrint from "@/containers/yearly-niyaaz/yearly-niyaaz-receipts/YearlyNiyaazReceiptPrint";
import YearlyLedgerEntryPrint from "@/containers/yearly-ledger/YearlyLedgerEntryPrint";
import ProjectTakhmeenReceiptPrint from "@/containers/projects/project-takhmeen-receipts/ProjectTakhmeenReceiptPrint";

import type { AuthlessRouteConfig } from "@/types/react-admin-config";

export const AUTHLESS_ROUTES: AuthlessRouteConfig[] = [
  { path: "/niyaaz-receipt", element: Receipt },
  { path: "/cont-rcpt/:id", element: RentReceiptPrint },
  { path: "/lagat-rcpt/:id", element: LagatReceiptPrint },
  { path: "/forgot-password", element: ForgotPassword },
  { path: "/reset-password", element: ResetPassword },
  { path: "/sabil-receipt", element: SabilReceipt },
  { path: "/fmb-receipt", element: FmbReceipt },
  { path: "/fmb-thali-distributor/login", element: FmbThaliDistributorLogin },
  { path: "/yn-rcpt/:id", element: YearlyNiyaazReceiptPrint },
  { path: "/yl-rcpt/:id", element: YearlyLedgerEntryPrint },
  { path: "/ptr-rcpt/:id", element: ProjectTakhmeenReceiptPrint },
];
